export const HIDE_PLAY_QUEUE = 'HIDE_PLAY_QUEUE';
export const TOGGLE_PLAY_QUEUE = 'TOGGLE_PLAY_QUEUE';
export const SHOW_PLAY_QUEUE = 'SHOW_PLAY_QUEUE';
